import { AxiosError } from 'axios';

import { STATUS_CODE } from '../../constants/status';

const errorNameMapper = {
  [STATUS_CODE.PERMANENT_REDIRECT]: 'PermanentRedirectError',
  [STATUS_CODE.BAD_REQUEST]: 'BadRequestError',
  [STATUS_CODE.UNAUTHORIZED]: 'UnauthorizedError',
  [STATUS_CODE.FORBIDDEN]: 'ForbiddenError',
  [STATUS_CODE.NOT_FOUND]: 'NotFoundError',
  [STATUS_CODE.CONFLICT]: 'ConflictError',
  [STATUS_CODE.INTERNAL_SERVER_ERROR]: 'InternalServerError',
  [STATUS_CODE.SERVICE_UNAVAILABLE]: 'ServiceUnavailableError',
};

/**
 * 카카오클라우드의 다양한 API에서 반환되는 서로 다른 형태의 error response 객체를 공통 인터페이스로 재정의 하기 위한 커스텀 에러 클래스
 */
class CustomAxiosError extends AxiosError {
  constructor(error: AxiosError) {
    super();

    const { message, code, config, request, response } = error;
    const { status } = error.response || {};

    this.name =
      typeof status !== 'undefined' && status in errorNameMapper
        ? errorNameMapper[status as keyof typeof errorNameMapper]
        : error.name;

    this.message = message;
    this.code = code;
    this.config = config;
    this.request = request;
    this.response = response;
  }
}

export default CustomAxiosError;
